export type BrandConfig = {
  brandName: string;
  NDD: string;
  sameAs: string[] | undefined;
  logo: string;
  ogImage: string;
  brandDescription: string;
  contactPoint: {
    contactType: string;
    email: string;
    telephone: string;
    availableLanguage: string[];
  };
  address: {
    streetAddress: string;
    addressLocality: string;
    addressCountry: string;
    addressRegion: string;
    postalCode: string;
  };
  isResellerBrand: boolean;
  showPrices: boolean;
  allowOnlinePurchase: boolean;
  DiscoverCTA: { label: string; path: string };
  resellerCTA: { label: string; path: string };
  becomeResellerCTA: { label: string; path: string };
  salesChannelLabel: string;
};

export const brandConfig: BrandConfig = {
  brandName: "TresorSafe",
  NDD: "https://thetresorsafe.com",
  logo: "https://thetresorsafe.com/TresorSafeLogo.webp",
  brandDescription:
    "TresorSafe est un fabricant Suisse renommé d'armoires à fusils et coffres forts, après avoir réussi à se positionner comme un représentant sur le marché Suisse, TresorSafe se développe en Europe.",
  sameAs: [],
  contactPoint: {
    contactType: "sales",
    email: "contact@thetresorsafe.com",
    telephone: "+33785756439",
    availableLanguage: ["fr"],
  },
  address: {
    streetAddress: "Avenue des Boveresses 28",
    addressLocality: "Lausanne",
    addressCountry: "CH",
    addressRegion: "Vaud",
    postalCode: "1010",
  },
  ogImage: "/public/TresorSafeLogo.webp",
  isResellerBrand: true,
  showPrices: true,
  allowOnlinePurchase: false,
  DiscoverCTA: {
    label: "Découvrir armoires à fusils",
    path: "/produits",
  },
  resellerCTA: {
    label: "Liste de nos revendeurs",
    path: "/revendeurs",
  },
  becomeResellerCTA: {
    label: "Devenir revendeur",
    path: "/contact",
  },
  salesChannelLabel: "Pour tout achat, contactez nos revendeurs agréés.",
};
